import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card h-100 text-center w-100 border-dark" }
const _hoisted_2 = {
  class: "card-header d-flex flex-row align-items-center justify-content-center p-1 bg-dark text-white",
  style: {"min-height":"3rem"}
}
const _hoisted_3 = { class: "my-0 mx-4" }
const _hoisted_4 = { class: "dropdown d-inline-flex mx-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary btn-block",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" })
], -1)
const _hoisted_6 = {
  tabindex: "-1",
  class: "dropdown-menu"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  href: "#",
  target: "_self",
  class: "dropdown-item"
}
const _hoisted_9 = {
  key: 0,
  class: "card-body p-1"
}
const _hoisted_10 = { class: "d-flex flex-column mh-100" }
const _hoisted_11 = { class: "card mb-1 border-secondary" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "row flex-nowrap align-items-center" }
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = { class: "badge bg-light text-dark" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = {
  key: 1,
  class: "card-body"
}
const _hoisted_23 = { class: "d-flex align-items-center justify-content-center h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.t('filterlist.header.text')), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredFilters, (filter) => {
            return (_openBlock(), _createElementBlock("li", {
              key: filter,
              onClick: ($event: any) => (_ctx.initFilter(filter))
            }, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.t(`filterlist.filter.${filter}.name`)), 1)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ])
    ]),
    (_ctx.filterMaps.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_draggable, {
              modelValue: _ctx.filterMaps,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterMaps) = $event)),
              "item-key": "id",
              handle: ".handle",
              class: "list-group overflow-auto"
            }, {
              item: _withCtx(({element, index}) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("header", {
                    title: _ctx.t('filterlist.event.draggable.title'),
                    class: "card-header handle py-1 bg-secondary text-white",
                    style: {"cursor":"move"}
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t(`filterlist.filter.${element.name}.name`)), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn close btn-secondary",
                          onClick: ($event: any) => (_ctx.store.commit('removeFilter', index))
                        }, _hoisted_20, 8, _hoisted_18)
                      ])
                    ])
                  ], 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(
                    element.name.charAt(0).toUpperCase() +
                      element.name.slice(1) +
                      'Filter'
                  ), {
                      modelValue: _ctx.filterMaps[index],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.filterMaps[index]) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('filterlist.notice.emptylist')), 1)
          ])
        ]))
  ]))
}